import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { NextButtonWrapper, forgotLinkStyle } from '../../LoginStyle';
import JoinSkipButton from '../../../components/join/JoinSkipButton';
import { DashlineSeparator, bottomLinkStyle, buttonStyle } from '../../../components/common/CommonStyle';
import TextLink from '../../../components/common/TextLink';
import colors from '../../../theme/colors';
import Button from '../../../atoms/buttons/Button';
import TextInputV2 from '../../../atoms/TextInputV2';
import { changeEmailVerifyPasswordAction } from '../../../actions/authActions';
import EmailCaption from './EmailCaption';
import { usePassOtpLink, emailInputStyle } from './ChangeEmailStyle';

const ChangeEmailPasswordForm = (props: any): ReactElement => {
  const { email, setChangeEmailStep, emailVerifyData } = props;
  const [password, setPassword] = useState<string>('');
  const [hasError, setHasError] = React.useState(emailVerifyData?.hasError ?? false);
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (emailVerifyData?.hasError) {
      setHasError(true);
    }
  }, [emailVerifyData]);

  const onChangePassword = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setPassword(e.target.value.replace(/\s/g, ''));

    if (!isEmpty(e.target.value) && hasError) {
      setHasError(false);
    }
  };

  const onBlurChangePassword = (): void => {
    setIsFocused(true);
  };

  const handlePasswordSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    dispatch(changeEmailVerifyPasswordAction(email, password, 'change_email'));
  };

  return (
    <>
      <EmailCaption email={email} label="We’ve sent a one-time passcode to:" />
      <DashlineSeparator />
      <TextInputV2
        id={'change_email_password'}
        data-test-id="text-change_email_password"
        type="password"
        showPassword={true}
        inputLabel="Please enter your password"
        value={password}
        onChange={onChangePassword}
        onBlur={onBlurChangePassword}
        customStyle={{ padding: '15px 0px 15px 0px' }}
        status={hasError ? 'error' : 'default'}
        statusMessage={hasError && emailVerifyData?.error?.message ? emailVerifyData?.error?.message : null}
        customInputStyle={{
          ...emailInputStyle,
          border: `1px solid ${!isFocused && password === '' ? (hasError ? '#DD0B24' : colors.gray['1300']) : hasError ? '#DD0B24' : colors.gray['1100']} !important`,
        }}
        isLogin={false}
        customStyleLabelContainer={{ marginBottom: '8px' }}
        passwordEyeColor={colors.light.gray.light}
      />
      <div style={{ textAlign: 'center' }}>
        <TextLink to="/restoring" style={forgotLinkStyle}>
          Forgot password
        </TextLink>
      </div>
      <NextButtonWrapper style={{ display: 'flex', flexDirection: 'column', marginTop: 20 }}>
        <Button
          disabled={isEmpty(password) || hasError}
          customStyle={buttonStyle}
          buttonType="primaryRed"
          type="button"
          name="changeEmail-password-submit"
          onClick={handlePasswordSubmit}
        >
          Next
        </Button>
        <JoinSkipButton
          data-test-id="use-otp-link"
          label="Use OTP Instead"
          onClick={() => setChangeEmailStep('change_email_otp')}
          customStyle={{ ...bottomLinkStyle, fontSize: 16 }}
          // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
          customWrapperStyle={usePassOtpLink}
        />
      </NextButtonWrapper>
    </>
  );
};

export default ChangeEmailPasswordForm;
